// helpdesk-frontend/src/api/modules/plAnalityka.js
// [AX-2 / P3, 2026-09-18] Analityka projektu (CPM): JEDEN model dla zakładek „Oś czasu"/„Przegląd", rekomendacji i PDF.
// Kontrakt: GET api/pl-projects/{id}/analityka → AnalitykaProjektuDto (src/DogSoft.Application/DTOs/PlProjects/PlAnalitykaDtos.cs).
// apiService.js jest ZAMKNIĘTY (api/modules/index.js §6.1) — dlatego metoda żyje tutaj.

/**
 * @param {import("axios").AxiosInstance} api
 */
export function attach(api) {
    return {
        /** Analityka CPM projektu: ES/EF/LS/LF, luzy, krawędzie, łańcuchy krytyczne, pętle, „bez terminu", liczniki. */
        getPlAnalityka: (projectId) => api.get(`/pl-projects/${projectId}/analityka`),
    };
}
